import React from 'react';
import {
  Slide,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  List,
  ListItem,
  ListItemText
} from '@material-ui/core';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export default function DirectionsModal({ open, setOpen }) {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      {/* <Button variant='outlined' color='primary' onClick={handleClickOpen}>
        Slide in alert dialog
      </Button> */}
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        scroll='paper'
        aria-labelledby='alert-dialog-directions'
        aria-describedby='alert-dialog-slide-description'
      >
        <DialogTitle id='alert-dialog-directions'>
          {'iDemand Historical Paths'}
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id='alert-dialog-slide-description'>
            Select anywhere on the map to get a historical estimate of how our
            wind products would have performed over the last 50 years. It will
            display Events according to the following criteria:
          </DialogContentText>
          <List dense>
            <ListItem alignItems='flex-start'>
              <ListItemText primary='Tropical storms (category&nbsp;0) within 50 miles' />
            </ListItem>
            <ListItem alignItems='flex-start'>
              <ListItemText primary='Minor hurricanes (category&nbsp;1-2) within 100 miles' />
            </ListItem>
            <ListItem alignItems='flex-start'>
              <ListItemText primary='Major hurricanes (category&nbsp;3-5) within 125 miles' />
            </ListItem>
            <ListItem alignItems='flex-start'>
              <ListItemText primary='Major hurricanes (category&nbsp;5) within 150 miles' />
            </ListItem>
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color='primary'>
            Get Started
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
